import React, { useState } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa';
import { Button } from '../assests/css/scroll-btn.js';
//tool-tip
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

const ScrollButton = () => {

	const [visible, setVisible] = useState(false)

	const toggleVisible = () => {
		const scrolled = document.documentElement.scrollTop;
		if (scrolled > 300) {
			setVisible(true)
		}
		else if (scrolled <= 300) {
			setVisible(false)
		}
	};

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	window.addEventListener('scroll', toggleVisible);

	return (
		<Button>
			<Tooltip radius="5" arrow="5" placement="bottom" fontSize="small" overlay={<div style={{fontSize:"x-small", padding:0, margin:0}}>Scroll to top</div>}><FaArrowCircleUp onClick={scrollToTop}
				style={{ display: visible ? 'inline' : 'none' }} />
			</Tooltip>
		</Button>
	);
}

export default ScrollButton;